import ReactDOM from "react-dom/client";
import { TheGroom } from "./components/TheGroom/TheGroom";
import { TheBride } from "./components/TheBride/TheBride";
import { WeAreGettingMarried } from "./components/WeAreGettingMarried/WeAreGettingMarried";
import { Footer } from "./components/Footer/Footer";
import { TheWedding } from "./components/TheWedding/TheWedding";
import { Artem } from "./components/Artem/Artem";
import { Svyat } from "./components/Svyat/Svyat";
import { Veta } from "./components/Veta/Veta";
import { Lena } from "./components/Lena/Lena";
import { Location } from "./components/Location/Location";
import { Rsvp } from "./components/Rsvp/Rsvp";
import { ImportantInformation } from "./components/ImportantInformation/ImportantInformation";
import { LoveLine } from "./components/LoveLine/LoveLine";

import "./scripts";

const theGroomEl = document.getElementById("the-groom");
const theBrideEl = document.getElementById("the-bride");
const weAreGettingMarriedEl = document.getElementById("we-are-getting-married");
const footerEl = document.getElementById("footer-onepage");
const theWeddingEl = document.getElementById("the-wedding");
const artemEl = document.getElementById("artem");
const svyatEl = document.getElementById("svyat");
const vetaEl = document.getElementById("veta");
const lenaEl = document.getElementById("lena");
const locationEl = document.getElementById("location");
const rsvpEl = document.getElementById("rsvp");
const informationEl = document.getElementById("giftregistry");
const lovelineEl = document.getElementById("loveline");

if (!!lovelineEl) {
  const root = ReactDOM.createRoot(lovelineEl);
  root.render(<LoveLine />);
}

if (!!theGroomEl) {
  const root = ReactDOM.createRoot(theGroomEl);
  root.render(<TheGroom />);
}

if (!!theBrideEl) {
  const root = ReactDOM.createRoot(theBrideEl);
  root.render(<TheBride />);
}

if (!!weAreGettingMarriedEl) {
  const root = ReactDOM.createRoot(weAreGettingMarriedEl);
  root.render(<WeAreGettingMarried />);
}

if (!!footerEl) {
  const root = ReactDOM.createRoot(footerEl);
  root.render(<Footer />);
}

if (!!theWeddingEl) {
  const root = ReactDOM.createRoot(theWeddingEl);
  root.render(<TheWedding />);
}

if (!!artemEl) {
  const root = ReactDOM.createRoot(artemEl);
  root.render(<Artem />);
}

if (!!svyatEl) {
  const root = ReactDOM.createRoot(svyatEl);
  root.render(<Svyat />);
}

if (!!vetaEl) {
  const root = ReactDOM.createRoot(vetaEl);
  root.render(<Veta />);
}

if (!!lenaEl) {
  const root = ReactDOM.createRoot(lenaEl);
  root.render(<Lena />);
}

if (!!locationEl) {
  const root = ReactDOM.createRoot(locationEl);
  root.render(<Location />);
}

if (!!rsvpEl) {
  const root = ReactDOM.createRoot(rsvpEl);
  root.render(<Rsvp />);
}

if (!!informationEl) {
  const root = ReactDOM.createRoot(informationEl);
  root.render(<ImportantInformation />);
}

// ReactDOM.createRoot(document.getElementById("loveline-1") as HTMLElement).render(
//   <img src={LOVELINE_1} alt="" style={{ filter: "grayscale(100%)" }} />
// );

// ReactDOM.createRoot(document.getElementById("loveline-2") as HTMLElement).render(
//   <img src={LOVELINE_1} alt="" style={{ filter: "grayscale(100%)" }} />
// );
